
import { IContact } from '@interfaces/chat/chatI';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';


export const contactSocketQueueSlice = createSlice({
    name: 'contactSocketQueue',
    initialState: {
        contacts: [],
    } as {contacts: IContact[]},
    reducers:{
        setContactSocketQueue: (state, action: PayloadAction<IContact>) => {
            const index = state.contacts.findIndex(c => action.payload.id === c.id);
            if(index === -1)
                state.contacts.push(action.payload);
            else
            {
                state.contacts[index] = action.payload;
            }
        },
        setContactsBulkSocketQueue: (state, action: PayloadAction<IContact[]>) => {
            state.contacts = action.payload;
        },
        removeContactSocketQueue: (state, action: PayloadAction<IContact>) => {
            const filteredData = state.contacts.filter(contact => contact.id !== action.payload.id);
            // console.log("removeContactSocketQueue", filteredData);
            state.contacts = filteredData;
        },
        cleanContactSocketQueue: (state, action: PayloadAction<IContact[]>) => {
            state.contacts = [];
        }
    }
});

export const {setContactSocketQueue, setContactsBulkSocketQueue, removeContactSocketQueue, cleanContactSocketQueue} = contactSocketQueueSlice.actions;
export default contactSocketQueueSlice.reducer;